import {
  type ATTACHMENT_TYPES,
  isApplicationDocuments,
} from '../../constants/attachmentTypes';

export const canPreviewDocument = (attachment: {
  isPdf?: boolean;
  type: ATTACHMENT_TYPES;
}) => attachment.isPdf || isApplicationDocuments(attachment.type);
